import { ToastrService } from 'ngx-toastr';
import { ClientService } from './../../../services/client.service';
import { CitiesModel } from '../../../models/cities.model';
import { UntypedFormGroup, UntypedFormControl, Validators, } from '@angular/forms';
import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { CitiesService } from 'src/app/shared/services/cities.service';
import { AddNewCityComponent } from '../add-new-city/add-new-city.component';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-add-new-client',
  templateUrl: './add-new-client.component.html',
  styleUrls: ['./add-new-client.component.scss'],
  standalone: false
})
export class AddNewClientComponent implements OnInit {
  @Input() updateInputValue = new EventEmitter();
  dmsAnalyze;
  kif = false;
  cities: Array<CitiesModel>;
  @Input() naziv;

  constructor(
    private cityService: CitiesService,
    private clientService: ClientService,
    private toastr: ToastrService,
    private translate: TranslateService,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
  ) { }

  clientForm = new UntypedFormGroup({
    komitent: new UntypedFormControl('', Validators.required),
    vrsta: new UntypedFormControl(2),
    identifikacioniBroj: new UntypedFormControl('', [
      Validators.required,
      this.isExactLength,
    ]),
    pdvBroj: new UntypedFormControl(null, this.isVATNumberExactLength),
    adminJedinica: new UntypedFormControl(1),
    grad: new UntypedFormControl(null, Validators.required),
    adresa: new UntypedFormControl('', Validators.required),
    telefon: new UntypedFormControl(''),
    eMail: new UntypedFormControl('', [Validators.email]),
  });

  private isExactLength(control) {
    return !(control.value.length < 13 || control.value.length > 13)
      ? null : { isExactLength: { valid: false, }, };
  }

  private isVATNumberExactLength(control) {
    return !(control.value?.length < 12 || control.value?.length > 12) ||
      !control.value ? null : { isVATNumberExactLength: { valid: false, }, };
  }

  ngOnInit(): void {
    this.getCities();
    if (this.dmsAnalyze) { this.getAnalyzeData(); }

    if (this.naziv) {
      this.clientForm.controls.komitent.setValue(this.naziv);
    }
  }

  onSubmit() {
    if (this.clientForm.valid) {
      this.createNewClient();
    } else {
      this.clientForm.markAllAsTouched();
    }
  }

  getAnalyzeData() {
    if (this.kif) {
      if (this.dmsAnalyze?.customerName) {
        this.clientForm.controls.komitent.setValue(this.dmsAnalyze?.customerName);
      }

      if (this.dmsAnalyze?.customerAddress) {
        this.clientForm.controls.adresa.setValue(this.dmsAnalyze?.customerAddress);
      }

      if (this.dmsAnalyze?.customerIdFix) {
        if (this.dmsAnalyze?.customerIdFix.length == 13) {
          this.clientForm.controls.identifikacioniBroj.setValue(this.dmsAnalyze?.customerIdFix);
        }
        else if (this.dmsAnalyze?.customerIdFix.length == 12) {
          this.clientForm.controls.pdvBroj.setValue(this.dmsAnalyze?.customerIdFix);
          this.clientForm.controls.identifikacioniBroj.setValue('4' + this.dmsAnalyze?.customerIdFix);
        }
        else if (this.dmsAnalyze?.customerIdFix.length > 13) {
          this.clientForm.controls.identifikacioniBroj.setValue(this.dmsAnalyze?.customerIdFix.substring(0, 13));
        } else {
          this.clientForm.controls.identifikacioniBroj.setValue(this.dmsAnalyze?.customerIdFix);
        }
      }
    }
    else {
      if (this.dmsAnalyze?.vendorName) {
        this.clientForm.controls.komitent.setValue(this.dmsAnalyze?.vendorName);
      }
      if (this.dmsAnalyze?.vendorAddressRoad) {
        this.clientForm.controls.adresa.setValue(this.dmsAnalyze?.vendorAddressRoad);
      }
      if (this.dmsAnalyze?.vendorAddressHouseNumber) {
        this.clientForm.controls.adresa.setValue(this.clientForm.controls.adresa.value + ' ' + this.dmsAnalyze?.vendorAddressHouseNumber);
      }

      if (this.dmsAnalyze?.vendorTaxIdFixed) {
        if (this.dmsAnalyze?.vendorTaxIdFixed.length == 13) {
          this.clientForm.controls.identifikacioniBroj.setValue(this.dmsAnalyze?.vendorTaxIdFixed);
        }
        else if (this.dmsAnalyze?.vendorTaxIdFixed.length == 12) {
          this.clientForm.controls.pdvBroj.setValue(this.dmsAnalyze?.vendorTaxIdFixed);
          this.clientForm.controls.identifikacioniBroj.setValue('4' + this.dmsAnalyze?.vendorTaxIdFixed);
        }
        else if (this.dmsAnalyze?.vendorTaxIdFixed.length > 13) {
          this.clientForm.controls.identifikacioniBroj.setValue(this.dmsAnalyze?.vendorTaxIdFixed.substring(0, 13));
        } else {
          this.clientForm.controls.identifikacioniBroj.setValue(this.dmsAnalyze?.vendorTaxIdFixed);
        }
      }
    }
  }

  getCities() {
    this.cities = [];
    this.cityService.getAllCities().subscribe((res) => {
      this.cities = res;

      if (this.dmsAnalyze?.vendorAddressPostalCode) {
        var city = this.cities.find(x => x.posstanskiBroj == this.dmsAnalyze?.vendorAddressPostalCode);
        if (city) {
          this.clientForm.controls.grad.setValue(city.sifra);
        }
      };
    });
  }

  createNewClient() {
    this.clientService.addNewClient(this.clientForm.value).subscribe(
      (res) => {
        this.toastr.success(this.translate.instant("MESSAGE.Uspješno kreiran komitent"));
        this.updateInputValue.emit(res.body.result.item.sifra);
        this.closeModal();
      },
      (err) => {
        console.log(err);
      }
    );
  }

  closeModal() {
    this.bsModalRef.hide();
  }

  openAddNewCityModal() {
    const initialState: ModalOptions = {
      /* initialState: {
      }, */
      class: "modal-dialog-centered modal-lg"
    };
    this.bsModalRef = this.modalService.show(AddNewCityComponent, initialState);
    this.bsModalRef.content.updateInputValue.subscribe((res: any) => {
      if (res) {
        this.getCities();
        this.clientForm.controls.grad.setValue(res);
      }
    });
  }
}
